import { useQuery } from '@tanstack/react-query';

import { individualsService, FetchIndividualsResponse } from '@aslanpay/portal-common-lib';

import {
  EmployeesCountByStatus,
  EmployeesStats,
} from 'app/components/Employees/EmployeesStatus/types';

const useFetchEmployeesStats = (companyId: string[]) => {
  return useQuery<FetchIndividualsResponse, Error, EmployeesStats>(
    ['fetchEmployeesStats', companyId],
    () =>
      individualsService.fetchIndividuals({
        role: ['EMPLOYEE'],
        companyId,
        page: 0,
        size: 999999,
      }),
    {
      select: (data: FetchIndividualsResponse) => {
        const employeesCountByStatus = data.list.reduce(
          (result, currentValue) => {
            if (currentValue.terminationDate && currentValue.status === 'ACTIVE') {
              // eslint-disable-next-line no-param-reassign
              result.LEAVING = result.LEAVING ? result.LEAVING + 1 : 1;
            } else {
              // eslint-disable-next-line no-param-reassign
              result[currentValue.status] = result[currentValue.status]
                ? result[currentValue.status] + 1
                : 1;
            }

            return result;
          },
          {
            CREATED: 0,
            INVITED: 0,
            ACTIVE: 0,
            DELETED: 0,
            PAUSED: 0,
            LEAVING: 0,
            RESTRICTED: 0,
            LEFT: 0,
          } as EmployeesCountByStatus
        );

        return {
          employeesCountByStatus,
          currentEmployeesCount:
            employeesCountByStatus.CREATED +
            employeesCountByStatus.INVITED +
            employeesCountByStatus.ACTIVE +
            employeesCountByStatus.LEAVING +
            employeesCountByStatus.RESTRICTED,
          total: data.total,
        };
      },
    }
  );
};

export default useFetchEmployeesStats;
